import React, { useReducer, useEffect, useContext } from 'react'
import OutletForm from './OutletForm';
import { Container, Row, Col } from 'react-bootstrap';
import AuthContext from '../../context/auth-context';
import GQL from '../../GQL';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core';
import moment from 'moment-timezone'
import NumberFormat from 'react-number-format';
import validate from 'validate.js';
import listPropinsi from '../Constants/Province';
import Kota from '../Constants/Kota'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const { listKotaCheck } = Kota;

const initialValue = {
  data: {
    kodeoutlet: '',
    namaoutlet: '',
    database: '',
    userdb: '',
    pwddb: '',
    tax: 0,
    service: 0,
    fullName: '',
    email: '',
    phoneNumber: '',
    address: '',
    country: 'IDN',
    province: '',
    city: '',
    zipCode: '',
    isTrialMode: false,
    trialKategori: 2,
    trialSubKategori: 20,
    trialBarang: 50,
    trialTransaksiPerDay: 20,
    connectHoman: false,
    mysqlHost: '',
    mysqlDb: '',
    mysqlUser: '',
    mysqlPwd: '',
    salesreferencecode: '',
    detail: [],
    contract: [],
    jumlahdevice: 0,
    usePassti: false,
    useCashlez: false,
    useQREN: false,
    useBarangOutlet: false,
    useDelivery: false,
    limitDelivery: 100,
    gojek: '',
    grab: '',
    useIposStock: false,
    usePoktan:false
  },
  isSaving: false,
  isLoading: false,
  error: null,
  reload: true
}

const reducer = (state, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoading: true,
        data: initialValue.data,
        error: null
      }
    case "LOADED":
      return {
        ...state,
        isLoading: false,
        data: action.data,
        reload: false
      }
    case "UPDATE":
      return {
        ...state,
        data: action.data
      }
    case "SAVING":
      return {
        ...state,
        isSaving: true,
        error: null
      }
    case "SAVED":
      return {
        ...state,
        isSaving: false,
        reload: true
      }
    case 'ERROR':
      return {
        ...state,
        isSaving: false,
        isLoading: false,
        error: action.error,
        reload: false
      }
    default: return state;
  }
}

const EditOutlet = (props) => {
  const defaultPage = props.match.params.page * 1 || 1;
  const defaultrowsPerPage = props.match.params.rowsPerPage * 1 || 5;
  let url = ''
  if (props.match.path.substring(1, 7) === "outlet") {
    url = "outlet"
  } else {
    url = "outletIsTes"
  }
  const { clientID, token } = useContext(AuthContext);
  const [state, dispatch] = useReducer(reducer, initialValue)

  useEffect(() => {
    var render = true;
    const { kodeoutlet } = props.match.params;
    if (state.reload && kodeoutlet && render) {
      var query = ` 
      query{
        outlet(kodeoutlet:"${kodeoutlet}"){
          kodeoutlet
          namaoutlet
          database
          userdb
          pwddb
          status
          userin
          userupt
          jamin
          jamupt
          fullName
          email
          phoneNumber
          address
          city
          country
          zipCode
          tax
          service
          isTrialMode
          province
          trialKategori
          trialSubKategori
          trialBarang
          trialTransaksiPerDay
          mysqlUser
          mysqlHost
          mysqlDb
          connectHoman
          salesreferencecode
          jumlahdevice
          usePassti
          useCashlez
          useQREN
          useBarangOutlet
          useDelivery
          useIposStock
          usePoktan
          limitDelivery
          isTes
          isOpname
          detail{
            urut
            payment{
              id
              namapayment
            }
            paymentDeskripsi
            paymentDate
            paymentAmount
            expiryDate
            userin
            jamin
            userupt
            jamupt
            tanggalPencairanKomisi
            transferKe
            nilaikomisi
            noreferensi
          }
          contract{
            tanggal
            harga
            komisisales
            userin
            userupt
            jamin
            jamupt
          }
          connectedDevice{
            deviceId
            statusid
            tanggaldaftar
            tanggalinvalidate
          }
          gambar
          gojek
          grab
          latitude
          longitude
        }
      }`
      GQL(query, clientID, token).then(res => {
        if (res.errors) throw res.errors;
        const { outlet } = res.data;
        outlet.detail = outlet.detail.sort((a, b) => {
          if (moment(moment(b.expiryDate)).isBefore(moment(a.expiryDate))) return -1;
          if (moment(moment(b.expiryDate)).isAfter(moment(a.expiryDate))) return 1;
          return 0;
        });
        outlet.contract = outlet.contract.sort((a, b) => {
          if (moment(moment(b.tanggal)).isBefore(moment(a.tanggal))) return -1;
          if (moment(moment(b.tanggal)).isAfter(moment(a.tanggal))) return 1;
          return 0;
        })
        if (outlet.mysqlUser == null) outlet.mysqlUser = '';
        if (outlet.mysqlHost == null) outlet.mysqlHost = '';
        if (outlet.mysqlDb == null) outlet.mysqlDb = '';
        if (outlet.mysqlPwd == null) outlet.mysqlPwd = '';
        render && dispatch({ type: "LOADED", data: outlet });
      }).catch(err => {
        console.log(err);
        alert("Server tidak dapat memenuhi permintaan Anda saat ini. Harap coba beberapa saat lagi");
        render && dispatch({ type: "ERROR", error: err });
      });
    }
    return () => {
      render = false;
    };
  }, [state.reload]);
  const handleChange = (key, value) => {
    const newState = Object.assign({}, state.data);
    newState[key] = value;
    dispatch({ type: "UPDATE", data: newState })
  }

  const validateForm = () => {
    const promNamaOutlet = new Promise((resolve, reject) => {
      const myFormat = /^(\+62|\+0|0|62)8(1[123]|52|51|53|21|22|23)[0-9]{5,9}$|^(\+62815|0815|62815|\+0815|\+62816|0816|62816|\+0816|\+62858|0858|62858|\+0814|\+62814|0814|62814|\+0814)[0-9]{5,9}$|^(\+62855|0855|62855|\+0855|\+62856|0856|62856|\+0856|\+62857|0857|62857|\+0857)[0-9]{5,9}$|^(\+62817|0817|62817|\+0817|\+62818|0818|62818|\+0818|\+62819|0819|62819|\+0819|\+62859|0859|62859|\+0859|\+0878|\+62878|0627|0629|06410642|0643|0644|0645|0646|0650|0651|0652|0653|0654|0655|0656|0657|0658|0659|061|0620|0621|0622|0623|0624|0625|0626|0627|0628|0630|0631|0632|0633|0634|0635|0636|0639|0751|0752|0753|0754|0755|0756|0757|0759|0760|0761|0762|0763|0764|0765|0766|0767|0768|0769|0624|0770|0771|0772|0773|0776|0777|0778|0779|0740|0741|0742|0743|0744|0745|0746|0747|0748|0702|0711|0712|0713|0714|0730|0731|0733|0734|0735|0715|0716|0717|0718|0719|0732|0736|0737|0738|0739|0721|0722|0723|0724|0725|0726|0727|0728|0729|021|0252|0253|0254|0257|022|0231|0232|0233|0234|0251|0260|0261|0262|0263|0264|0265|0266|0267|0274|024|0271|0272|0273|0274|0275|0276|0280|0281|0282|0283|0284|0285|0286|0287|0289|0291|0292|0293|0294|295|0296|0297|0298|0299|0356|031|0321|0322|0323|0324|0325|0327|0328|0331|0332|0333|0334|0335|0336|0338|0341|0342|0343|0351|0352|0353|0354|0355|0356|0357|0358|0361|0362|0363|0365|0366|0368| 0364|0370|0371|0372|0373|0374|0376|0380|0381|0382|0383|0384|0385|0386|0387|0388|0389|0561|0562|0563|0564|0565|0567|0568|0534|0513|0522|0525|0526|0528|0531|0532|0536|0537|0538|0539|0511|0512|0517|0518|0526|0527|0541|0542|0543|0545|0548|0549|0554|0551|0552|0553|0556|0430|0431|0432|0434|0438|0435|0443|0445|0450|0451|0452|0453|0454|0457|0458|0461|0462|0463|0464|0465|0455|0422|0426|0428|0410|0411|0413|0414|0417|0418|0419|0420|0421|0423|0427|0471|0472|0473|0474|0475|0481|0482|0484|0485|0401|0402|0403|0404|0405|0408|0910|0911|0913|0914|0915|0916|0917|0918|0921|0922|0923|0924|0927|0929|0931|0901|0902|0951|0952|0955|0956|0957|0966|0967|0969|0971|0975|0980|0981|0983|0984|0985|0986|0878|62878|\+0877|\+62877|0877|62877)[0-9]{5,9}$|^(\+62|\+0|0|62)8(28)[0-9]{5,9}$|^(\+62|\+0|0|62)8(3[128])[0-9]{5,9}$|^(\+62|\+0|0|62)8(8[1278])[0-9]{5,9}$|^(\+62|\+0|0|62)8(9[678])[0-9]{5,9}$/g;
      const constraint = {
        namaoutlet: {
          length: {
            minimum: 3,
            message: "Nama outlet minimal terdiri dari 3 huruf"
          },
        }, fullName: {
          length: {
            minimum: 3,
            message: "Nama minimal terdiri dari 3 huruf"
          }
        }, email: {
          email: {
            message: "Email tidak valid"
          }
        }, address: {
          length: {
            miminum: 10,
            message: "Alamat terlalu pendek. Harap mengisi alamat lengkap"
          }
        },
        phoneNumber: {
          length: {
            minimum: 9,
            message: "Nomor Handphone terlalu pendek"
          },
          // format: {
          //   pattern: myFormat,
          //   message: "Nomor Handphone tidak sesuai dengan format operator Indonesia."
          // }
        },
        country: {
          inclusion: {
            within: ["IDN"],
            message: "Harap memilih negara yang valid"
          }
        },
        province: {
          inclusion: {
            within: listPropinsi,
            message: "Harap memilih propinsi yang valid"
          }
        },
        city: {
          inclusion: {
            within: listKotaCheck,
            message: "Harap memilih kota yang valid"
          }
        },
        zipCode: {
          length: {
            is: 5,
            message: "Harap mengisi kode pos dengan format yang sesuai"
          },
          format: {
            pattern: "[0-9]+",
            message: "Mohon mengisi kode pos dengan nomor saja"
          }
        },
        tax: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "Harap mengisi persentase pajak yang sesuai"
          }
        },
        service: {
          numericality: {
            greaterThanOrEqualTo: 0,
            lessThanOrEqualTo: 100,
            message: "Harap mengisi persentase service yang sesuai"
          }
        }
      }
      const validator = validate(state.data, constraint, { fullMessages: false });
      console.log(validator);
      if (validator === undefined) {
        resolve();
      } else {
        reject(validator);
      }
    })
    return Promise.all([promNamaOutlet]);
  }


  const handleUpdate = () => {
    validateForm().then(() => {
      dispatch({ type: "SAVING" });
      const { kodeoutlet, namaoutlet, fullName, email, phoneNumber, address, city, country, zipCode, tax, service, isTrialMode, trialKategori, trialSubKategori, trialBarang, trialTransaksiPerDay, mysqlUser, mysqlPwd, mysqlHost, mysqlDb, connectHoman, province, salesreferencecode, jumlahdevice, usePassti, useCashlez, isTes, isOpname, useQREN, useBarangOutlet, useDelivery, limitDelivery, gojek, grab, latitude, longitude, useIposStock, usePoktan } = state.data;
      const _address = address.replace(/\n/g, "<BR>");
      let queryAddition = ''
      if (mysqlUser) {
        queryAddition += `,mysqlUser:"${mysqlUser}"`
      }
      if (mysqlPwd) {
        queryAddition += `,mysqlPwd:"${mysqlPwd}"`
      }
      if (mysqlHost) {
        queryAddition += `,mysqlHost:"${mysqlHost}"`
      }
      if (mysqlDb) {
        queryAddition += `,mysqlDb:"${mysqlDb}"`
      }
      const query = `
        mutation{
          updateOutlet(
            input:{
              kodeoutlet:"${kodeoutlet}",
              namaoutlet:"${namaoutlet}",
              fullName:"${fullName}",
              email:"${email}",
              phoneNumber:"${phoneNumber}",
              address:"${_address}",
              city:"${city}",
              country:"${country}",
              zipCode:"${zipCode}",
              tax:${tax},
              service:${service},
              isTrialMode:${isTrialMode},
              connectHoman:${connectHoman},
              province:"${province}",
              salesreferencecode:"${salesreferencecode}",
              trialKategori:${trialKategori},
              trialSubKategori:${trialSubKategori},
              trialBarang:${trialBarang},
              trialTransaksiPerDay:${trialTransaksiPerDay},
              jumlahdevice:${jumlahdevice},
              usePassti:${usePassti},
              useCashlez:${useCashlez},
              useQREN:${useQREN},
              useBarangOutlet:${useBarangOutlet}
              isTes:${isTes},
              isOpname:${isOpname},
              useDelivery:${useDelivery},
              limitDelivery:${limitDelivery},
              gojek:"${gojek}",
              grab:"${grab}",
              latitude:"${latitude}",
              longitude:"${longitude}",
              useIposStock:${useIposStock},
              usePoktan: ${usePoktan}
              ${queryAddition}
            }
          )
        }
      `
      GQL(query, clientID, token).then(resp => {
        if (resp.errors) throw resp.errors;
        if (resp.data.updateOutlet) {
          dispatch({ type: "SAVED" });
          alert("Outlet berhasil perbaharui");
        }
      }).catch(err => {
        if (Array.isArray(err)) {
          if (err.length > 0) {
            if (err[0].message === "Data Tidak Ditemukan") return (dispatch({ type: "NODATA" }));
          }
        }
        dispatch({ type: "FAILED", error: err });
      })
    }).catch(err => {
      console.log(err)
      const keys = Object.keys(err);
      var errorMessage = "";
      for (const key of keys) {
        errorMessage += err[key] + "\n";
      }
      // console.log(err);
      alert(errorMessage);
    })
  }

  const handleNewContract = () => {
    props.history.push(`/outletcontract/${state.data.kodeoutlet}`);
  }
  const handleNewDetail = () => {
    props.history.push(`/outletdetail/${state.data.kodeoutlet}`);
  }

  const handleEject = (deviceId) => {
    const yakin = window.confirm(`Yakin akan melakukan eject terhadap ${deviceId}?`);
    if (yakin) {
      dispatch({ type: "SAVING" });
      const query = `
        mutation{
          invalidateDevice(kodeoutlet:"${state.data.kodeoutlet}",deviceId:"${deviceId}")
        }
      `
      GQL(query, clientID, token).then(resp => {
        if (resp.errors) throw resp.errors;
        if (resp.data.invalidateDevice) {
          dispatch({ type: "SAVED" });
          alert("Device berhasil dieject");
        }
      }).catch(err => {
        if (Array.isArray(err)) {
          if (err.length > 0) {
            if (err[0].message === "Data Tidak Ditemukan") return (dispatch({ type: "NODATA" }));
          }
        }
        dispatch({ type: "FAILED", error: err });
      })
    }
  }
  const btnBack = () => {
    props.history.push(`/${url}/${defaultPage}/${defaultrowsPerPage}`)
  }
  return (
    <Container>
      <h3 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom"><ArrowBackIosIcon className="btnback" onClick={btnBack} />  Form Outlet</h3>
      <OutletForm data={state.data} handleChange={handleChange} clientID={clientID} token={token} dispatch={dispatch}  push={props.history.push}/>
      <Row style={{ marginTop: 20, marginBottom: 20 }}>
        <Col xs={12} className="text-center">
          <Button variant="contained" color="primary" onClick={handleUpdate}>UPDATE</Button>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col xs={12}>
          <h3 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom">Detail</h3>
          <Button style={{ marginTop: 10, marginBottom: 20 }} variant="contained" color="primary" onClick={handleNewDetail}>Tambah</Button>
          <Paper className="table-responsive">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  {/* <TableCell style={{ width: 80 }}>Action</TableCell> */}
                  <TableCell style={{ minWidth: 140 }}>Payment</TableCell>
                  <TableCell>Deskripsi</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell style={{ minWidth: 140 }}>Berlaku Hingga</TableCell>
                  <TableCell style={{ minWidth: 140 }}>Pencairan Komisi</TableCell>
                  <TableCell>Keterangan P.Komisi</TableCell>
                  <TableCell style={{ minWidth: 140 }}>User Input</TableCell>
                  <TableCell style={{ minWidth: 140 }}>User Update</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.data.detail && state.data.detail.map((el, idx) => {
                  const keteranganKomisi = []
                  if (el.transferKe && el.noreferensi && el.nilaikomisi) {
                    keteranganKomisi.push(<span key={`${idx.toString()}-1`}>{`${el.transferKe} - ${el.noreferensi}`}</span>)
                    keteranganKomisi.push(<br key={`${idx.toString()}-2`} />)
                    keteranganKomisi.push(<strong key={`${idx.toString()}-3`}><NumberFormat value={el.nilaikomisi} displayType={'text'} thousandSeparator={true} /></strong>)
                  }
                  return (
                    <TableRow key={idx.toString()}>
                      <TableCell>{idx + 1}</TableCell>
                      {/* <TableCell>
                      <Button variant="contained" color="primary" style={{ margin: 5 }}>Edit</Button>
                      <Button variant="contained" style={{ backgroundColor: 'red', margin: 5 }}>Hapus</Button>
                    </TableCell> */}
                      <TableCell>{el.payment.namapayment}<br />{moment(el.paymentDate).format("DD MMM YYYY")}</TableCell>
                      <TableCell>{el.paymentDeskripsi}</TableCell>
                      <TableCell align="right"><NumberFormat value={el.paymentAmount} displayType={'text'} thousandSeparator={true} /></TableCell>
                      <TableCell>{moment(el.expiryDate).format("DD-MMM-YYYY")}</TableCell>
                      <TableCell>{el.tanggalPencairanKomisi ? `${moment(el.tanggalPencairanKomisi).format("DD MMM YYYY")}` : `Belum Cair`}</TableCell>
                      <TableCell align="center">{(el.transferKe && el.noreferensi && el.nilaikomisi) ? keteranganKomisi : `Belum Cair`}</TableCell>
                      <TableCell align="center">{el.userin}<br />{moment(el.jamin).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                      <TableCell align="center">{el.userupt}<br />{moment(el.jamupt).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Paper>
        </Col>
      </Row>
      <Row style={{ marginTop: 20, marginBottom: 20 }}>
        <Col xs={12}>
          <h3 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom">Contract</h3>
          <Button style={{ marginTop: 10, marginBottom: 20 }} variant="contained" color="primary" onClick={handleNewContract}>Kontrak Baru</Button>
          <Paper className="table-responsive">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell style={{ minWidth: 220 }}>Tanggal</TableCell>
                  <TableCell>Harga Kontrak</TableCell>
                  <TableCell>Komisi Sales</TableCell>
                  <TableCell style={{ minWidth: 220 }}>Input</TableCell>
                  <TableCell style={{ minWidth: 220 }}>Update</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.data.contract && state.data.contract.map((el, idx) => (
                  <TableRow key={idx.toString()}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{moment(el.tanggal).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                    <TableCell align="right"><NumberFormat value={el.harga} displayType={'text'} thousandSeparator={true} /></TableCell>
                    <TableCell align="right"><NumberFormat value={el.komisisales} displayType={'text'} thousandSeparator={true} /></TableCell>
                    <TableCell align="center">{el.userin}<br />{moment(el.jamin).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                    <TableCell align="center">{el.userupt}<br />{moment(el.jamupt).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Col>
      </Row>
      <Row style={{ marginTop: 20, marginBottom: 20 }}>
        <Col xs={12}>
          <h3 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom">Device Management</h3>
          <Paper className="table-responsive">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Device ID</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Tanggal Daftar</TableCell>
                  <TableCell>Tanggal Invalidate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.data.connectedDevice && state.data.connectedDevice.map((el, idx) => (
                  <TableRow key={idx.toString()}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>
                      {el.deviceId}
                      {el.statusid === 1 && (
                        <Button style={{ marginLeft: 10 }} color="primary" onClick={handleEject.bind(this, el.deviceId)}>Eject</Button>
                      )}
                    </TableCell>
                    <TableCell>{el.statusid === 1 ? "Aktif" : "Tidak Aktif"}</TableCell>
                    <TableCell align="center">{moment(el.tanggaldaftar).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                    <TableCell align="center">{el.tanggalinvalidate && moment(el.tanggalinvalidate).format("DD MMM YYYY hh:mm:ss a")}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Col>
      </Row>
    </Container>
  );
}

export default EditOutlet;